module.exports = __webpack_public_path__ + "img/pasta-e-fagioli.54176798.png";